import { httpDelete, httpGet, httpPatch, httpPost } from "../connection";

interface CreateCustomFieldRequest {
  description?: string | null;
  editor_type: string;
  field_name: string;
  is_required: number;
  options?: string[] | null;
  type_ids?: number[] | null;
  sort_value: number;
  linked_id?: number;
  category: string;
  enabled?: number;
  external_enabled?: number;
}

interface UpdateCustomFieldRequest extends Partial<CreateCustomFieldRequest> {
  field_id: number;
}

export const getCustomFields = async (params: { category?: string }) =>
  (await httpGet("/custom-fields", params)).data;

export const createCustomField = async (values: CreateCustomFieldRequest) =>
  await httpPost("/custom-fields", values);

export const updateCustomField = async (values: UpdateCustomFieldRequest) =>
  await httpPatch(`/custom-fields/${values.field_id}`, values);

export const deleteCustomField = async (field_id: number) =>
  await httpDelete(`/custom-fields/${field_id}`);

const CustomFieldsApi = {
  getCustomFields,
  createCustomField,
  updateCustomField,
  deleteCustomField,
};

export default CustomFieldsApi;
